import React from 'react'
import LifeInsuranceForm from './Components/LifeInsuranceForm'

const LifeInsurance = () => {
    return (
        // {/* x---------------------------------x LifeInsurance Form x---------------------------------x */}
        <div className="grid grid-cols-1 gap-2 coustom-card">
            <div className="mx-0 px-0">
                <div className="h-full rounded-lg">
                    <div className="card-header justify-between">
                        <h2 className="sm:text-2xl text-lg font-semibold text-dark p-4" >Life Insurance Application Form</h2>
                    </div>
                    <div className="card-body sm:p-6 p-4 rounded-2xl">
                        {/* x---------------------------------x LifeInsurance Form Section x---------------------------------x */}
                        <LifeInsuranceForm />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LifeInsurance